'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from 'react';

type CommandMenuProps = {
  isSearching: boolean;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
};

const CommandMenu = createContext({} as CommandMenuProps);

export function useCommandMenu() {
  const context = useContext(CommandMenu);
  if (!context) {
    throw new Error('Use this component under command menu provider');
  }
  return context;
}

function CommandMenuProvider({ children }: { children: ReactNode }) {
  const [isSearching, setIsSearching] = useState(false);
  return (
    <CommandMenu.Provider
      value={{
        isSearching,
        setIsSearching
      }}
    >
      {children}
    </CommandMenu.Provider>
  );
}

export default CommandMenuProvider;
